import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import DealSubmissionForm from './components/DealSubmissionForm';

const SubmitDealPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#2F6FE4] via-[#1e5bc6] to-[#14B8A6] text-white py-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/10"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Submit a Client Deal
            </h1>
            <p className="text-xl md:text-2xl mb-6 text-white/95">
              Brokers can submit client information below to begin the service process with The Broker Marketplace.
            </p>
            <p className="text-base md:text-lg text-white/90 max-w-3xl mx-auto">
              Please complete the form with accurate client information so our team can review the submission and begin processing.
            </p>
          </div>
        </div>
      </section>

      {/* Broker Instructions */}
      <section className="bg-gradient-to-br from-gray-50 to-white py-12">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-md p-8 border-l-4 border-[#2F6FE4]">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Broker Instructions
            </h2>
            <div className="space-y-3 text-gray-700">
              <p className="text-base leading-relaxed">
                This page is for approved broker partners submitting a client deal to The Broker Marketplace.
              </p>
              <p className="text-base leading-relaxed">
                Please submit accurate broker and client information. Incomplete submissions may delay processing.
              </p>
              <p className="text-base leading-relaxed font-medium">
                Services will not begin until the required payment has been received.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Deal Submission Form */}
      <Suspense fallback={<div className="py-20 text-center">Loading...</div>}>
        <DealSubmissionForm />
      </Suspense>

      {/* Submission Notice */}
      <section className="bg-gradient-to-br from-gray-50 to-white py-12">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-md p-8 border-l-4 border-[#14B8A6]">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Submission Notice
            </h2>
            <div className="space-y-3 text-gray-700">
              <p className="text-base leading-relaxed">
                After submitting this form our team will review the deal submission and contact the broker if additional information is required.
              </p>
              <p className="text-base leading-relaxed">
                Submission of this form does not mean services have started.
              </p>
              <p className="text-base leading-relaxed font-medium">
                Services begin only after the required payment has been received by The Broker Marketplace.
              </p>
              <p className="text-base leading-relaxed">
                The Broker Marketplace does not guarantee credit score increases, funding approvals, or specific financial results.
              </p>
              <p className="text-base leading-relaxed">
                Reporting timelines vary depending on credit bureau reporting cycles and vendor processing timelines.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What Happens Next */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
              What Happens Next
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {/* Step 1 */}
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-[#2F6FE4] to-[#1e5bc6] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">1</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Review Submission
                </h3>
                <p className="text-sm text-gray-600">
                  Your deal submission is reviewed.
                </p>
              </div>

              {/* Step 2 */}
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-[#2F6FE4] to-[#1e5bc6] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">2</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Additional Information
                </h3>
                <p className="text-sm text-gray-600">
                  Our team may request additional information.
                </p>
              </div>

              {/* Step 3 */}
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-[#2F6FE4] to-[#1e5bc6] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">3</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Payment Required
                </h3>
                <p className="text-sm text-gray-600">
                  Payment must be received before services begin.
                </p>
              </div>

              {/* Step 4 */}
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-[#14B8A6] to-[#0d9488] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">4</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Service Begins
                </h3>
                <p className="text-sm text-gray-600">
                  Once payment is confirmed the requested service begins processing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SubmitDealPage;